<template>
  <section>
    <div v-if="stage !== 'service'">
      {{ appointment.service.title }} <template v-if="appointment.service.price && appointment.service.price != ''">({{appointment.service.price}})</template>
      <button v-if="appointment.service.code==''" @click="setStage('service')">Select a service</button>
      <button v-if="appointment.service.code!=''" @click="setStage('service')">Change service</button>
    </div>
    <div v-if="stage !== 'service' && stage !== 'location'">
      {{ appointment.practice.post_title }}
      <button v-if="appointment.practice.ID === 0" @click="setStage('location')">Select a location</button>
      <button v-if="appointment.practice.ID !== 0" @click="setStage('location')">Change location</button>
    </div>
    <div v-if="stage !== 'service' && stage !== 'location' && stage !== 'date'">
      <div class="appointment-date">
        <div>
          {{ appointment.date.date }}, {{ appointment.date.time }}
          <button v-if="appointment.date.id ===''" @click="setStage('date')">Select an appointment</button>
          <button v-if="appointment.date.id !==''" @click="setStage('date')">Change date</button>
          <div>
            <span class="appointment-duration">({{appointment.service.duration}} minutes appointment)</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BookingStages",
  props: ["appointment", "stage"],
  watch: {
    stage(newValue) {
      this.onStageChanged(newValue);
    }
  },
  methods: {
    setStage(stage) {
      this.$emit("setStage", stage);
    },
    onStageChanged(newValue) {
      //states: service => location => date => customer
      let stage_url = newValue;
      if (newValue === "date") {
        stage_url = "date-and-time";
      } else if (newValue === "customer") {
        stage_url = "personal-details";
      }
      stage_url = `/${stage_url}`;
      const frombackbutton = this.isTransitionFromBackButton ?? false;
      if (!frombackbutton) {
        window.history.pushState({"page_id": newValue}, "", stage_url);
      }
      this.isTransitionFromBackButton = false;

      let step = 0;
      if (newValue === "location") {
        step = 1;
      } else if (newValue === "date") {
        step = 2;
      } else if (newValue === "customer") {
        step = 3;
      }
      if (step > 0) {
        this.addToGTMDataLayer(step);
      }
    },
    addToGTMDataLayer(step) {
      window.dataLayer = window.dataLayer || [];
      if (step > 1) {
        window.dataLayer.push({
          'event': 'eec.checkout',
          'ecommerce': {
            'checkout': {
              actionField: {
                'step': step
              }
            }
          }
        });
      } else if (step == 1) {
        window.dataLayer.push({
          'event': 'eec.checkout',
          'ecommerce': {
            'checkout': {
              actionField: {
                'step': step
              },
              products:[{
                'name': this.appointment.service.title,
                'id': this.appointment.service.id,
                'price': this.appointment.service.price ?? '',
                'quantity': 1,
                'brand': 'Leightons Opticians & Hearing Care',
                'category': 'Hearing Services'
              }]
            }
          }
        });
      }
    }
  },
  mounted() {
    const thisView = this;
    const PAGE_IDs = ["service", "location", "date", "customer"];
    window.addEventListener("popstate", function(e) {
      e.preventDefault();
      const page_id = e.state.page_id;
      if (page_id && PAGE_IDs.includes(page_id)) {
        thisView.isTransitionFromBackButton = true;
        thisView.setStage(page_id);
      }
    });
    window.history.pushState({"page_id": "service"}, "", "/service");
  }
};
</script>

<style lang="postcss" scoped>
section {
  @apply text-center;

  > div {
    @apply bg-purple-darker px-[10px] py-[30px] uppercase text-[18px] tracking-wider font-avenir-medium text-white;

    button {
      @apply text-white text-base underline ml-[10px] font-avenir-medium;
    }

    &:nth-child(2) {
      @apply bg-purple-darker/60;
    }
    &:nth-child(3) {
      @apply bg-purple-darker/40;
    }

    .appointment-date {
      @apply flex justify-center;

      div div {
        @apply flex justify-start;
      }
    }

    span {
      @apply w-full text-white text-[16px] text-center lowercase tracking-wide font-avenir-book;
    }
  }
}
</style>